import { DefaultTheme } from 'styled-components'

export const genericPDPBreakpoint: keyof DefaultTheme['breakpoints'] = 'mobileStyleThreshold'
